import { render, staticRenderFns } from "./FlightSectionTravellersCollapse.vue?vue&type=template&id=9f43876c&scoped=true&"
import script from "./FlightSectionTravellersCollapse.vue?vue&type=script&lang=js&"
export * from "./FlightSectionTravellersCollapse.vue?vue&type=script&lang=js&"
import style0 from "./FlightSectionTravellersCollapse.vue?vue&type=style&index=0&id=9f43876c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f43876c",
  null
  
)

export default component.exports